//import angular from 'angular';
require('angular');
require('angular-ui-router');
require('angular-ui-bootstrap-tpls');

var ngEnter = require('./Directives/ngEnter.js');

// product wizard app
(function () {
    var productWizardColor = require('./Controllers/productWizardColor');
    var productWizardStyle = require('./Controllers/productWizardStyle');
    var productWizardPrimaryColor = require('./Controllers/productWizardPrimaryColor');
    var productWizardDesignerColor = require('./Controllers/productWizardDesignerColor');
    var productWizardStoneType = require('./Controllers/productWizardStoneType');

    var productWizardApp = angular.module('productWizard', ['ui.router']);
    productWizardApp.controller('productWizardColor', productWizardColor);
    productWizardApp.controller('productWizardStyle', productWizardStyle);
    productWizardApp.controller('productWizardPrimaryColor', productWizardPrimaryColor);
    productWizardApp.controller('productWizardDesignerColor', productWizardDesignerColor);
    productWizardApp.controller('productWizardStoneType', productWizardStoneType);
    productWizardApp.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/color');
        $stateProvider
        .state('color', {
            url: '/color?colors',
            views: {
                body: {
                    templateUrl: '/app/dist/templates/wizardColor.html',
                    controller: 'productWizardColor'
                }
            }
        })
        .state('style', {
            url: '/style?style',
            views: {
                body: {
                    templateUrl: '/app/dist/templates/wizardStyle.html',
                    controller: 'productWizardStyle'
                }
            }
        })
        .state('primary-color', {
            url: '/primary-color?style&primaryColor',
            views: {
                body: {
                    templateUrl: '/app/dist/templates/wizardPrimaryColor.html',
                    controller: 'productWizardPrimaryColor'
                }
            }
        })
        .state('designer-color', {
            url: '/designer-color?style&primaryColor&mode&colors',
            views: {
                body: {
                    templateUrl: '/app/dist/templates/wizardDesignerColor.html',
                    controller: 'productWizardDesignerColor'
                }
            }
        })
        .state('stone-type', {
            url: '/stone-type?previous&colors',
            views: {
                body: {
                    templateUrl: '/app/dist/templates/wizardStoneType.html',
                    controller: 'productWizardStoneType'
                }
            }
        });
    }]);
})();

// Product like items
(function () {
    var productItemList = require('./Controllers/productItem');

    var productItemApp = angular.module('productItem', ['ui.router','ui.bootstrap']);
    productItemApp.controller('productItemList', productItemList);
    productItemApp.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise("/");
        $stateProvider.state('likeItems', {
            url: '/',
            views: {
                'likeItems': {
                    templateUrl: '/app/dist/templates/productSearchResults.html',
                    controller: 'productItemList'
                }
            }
        });
    }]);
})();

// product search app
(function () {
    var productSearchFilters = require('./Controllers/productSearchFilters');
    var productSearchHeader = require('./Controllers/productSearchHeader');
    var productSearchResults = require('./Controllers/productSearchResults');

    var productSearchApp = angular.module('productSearch', ['ui.router', 'ui.bootstrap']);
    productSearchApp.controller('productSearchFilters', productSearchFilters);
    productSearchApp.controller('productSearchHeader', productSearchHeader);
    productSearchApp.controller('productSearchResults', productSearchResults);
    productSearchApp.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/?category=slabs');
        $stateProvider
        .state('search', {
            url: '/?category&subcategory&colors&thickness&finish&country&text' + 
                '&priceMin&priceMax' +
                '&lengthMin&heightMin' +
                '&movementMin&movementMax' +
                '&colorRangeMin&colorRangeMax' +
                '&abrasionResistanceMin&abrasionResistanceMax' +
                '&stainResistanceMin&stainResistanceMax' +
                '&etchingResistanceMin&etchingResistanceMax' +
                '&heatResistanceMin&heatResistanceMax' +
                '&uvResistanceMin&uvResistanceMax' +
                '&availability' +
                '&sort',
            views: {
                'filters': {
                    templateUrl: '/app/dist/templates/productSearchFilters.html',
                    controller: 'productSearchFilters'
                },
                'header': {
                    templateUrl: '/app/dist/templates/productSearchHeader.html',
                    controller: 'productSearchHeader'
                },
                'results': {
                    templateUrl: '/app/dist/templates/productSearchResults.html',
                    controller: 'productSearchResults'
                }
            }
        });
    }]);

    // captures the enter click for the name input so that the page doesn't refresh on its own
    productSearchApp.directive('ngEnter', ngEnter);
})();

// fabrication item search app
(function () {
    var fabricationItemSearchFilters = require('./Controllers/fabricationItemSearchFilters');
    var fabricationItemSearchHeader = require('./Controllers/fabricationItemSearchHeader');
    var fabricationItemSearchResults = require('./Controllers/fabricationItemSearchResults');

    var fabricationItemSearchApp = angular.module('fabricationItemSearch', ['ui.router', 'ui.bootstrap']);
    fabricationItemSearchApp.controller('fabricationItemSearchFilters', fabricationItemSearchFilters);
    fabricationItemSearchApp.controller('fabricationItemSearchHeader', fabricationItemSearchHeader);
    fabricationItemSearchApp.controller('fabricationItemSearchResults', fabricationItemSearchResults);
    fabricationItemSearchApp.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/?category=adhesives%20~2F%20sealers%20~2F%20cleaners');
        $stateProvider
            .state('search', {
                url: '/?category&subcategory&manufacturer&text&sort',
                views: {
                    'filters': {
                        templateUrl: '/app/dist/templates/fabricationItemSearchFilters.html',
                        controller: 'fabricationItemSearchFilters'
                    },
                    'header': {
                        templateUrl: '/app/dist/templates/fabricationItemSearchHeader.html',
                        controller: 'fabricationItemSearchHeader'
                    },
                    'results': {
                        templateUrl: '/app/dist/templates/fabricationItemSearchResults.html',
                        controller: 'fabricationItemSearchResults'
                    }
                }
            });
    }]);

    // captures the enter click for the name input so that the page doesn't refresh on its own
    fabricationItemSearchApp.directive('ngEnter', ngEnter);
})();

// product detail search app
(function () {
    var productDetailSearchApp = angular.module('productDetailSearch', ['ui.bootstrap']);

    productDetailSearchApp.controller('productDetailSearchHeader', ['$scope', function ($scope) {
        $scope.items = window.MG.productNames;
        $scope.textInput = '';

        // product detail seach
        $scope.updateSearchText = function () {
            window.location.href = '/products/#/?category=slabs&text=' + $scope.textInput;
        };
    }]);

    // captures the enter click for the name input so that the page doesn't refresh on its own
    productDetailSearchApp.directive('ngEnter', ngEnter);
})();
